/* eslint-disable import/no-deprecated */
import React, { useContext, useLayoutEffect } from 'react';
import { identifyComponent } from '../../util';
import { Text } from '../Text';
import { CollapsibleSectionContext } from './Context';
import { getLabelId } from './utils';

interface CollapsibleSectionLabelProps extends React.ComponentProps<typeof Text> {
  children: string;
}

export const CollapsibleSectionLabel: React.FunctionComponent<CollapsibleSectionLabelProps> = ({
  children,
  ...rest
}) => {
  const { id, setHasLabel } = useContext(CollapsibleSectionContext);
  useLayoutEffect(() => {
    setHasLabel(true);
    return () => setHasLabel(false);
  }, [setHasLabel]);

  return (
    <Text
      data-component="CollapsibleSectionLabel"
      id={getLabelId(id)}
      {...rest}
      {...identifyComponent('collapsible-section-label', rest)}
    >
      {children}
    </Text>
  );
};
